import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { sesionActual } from '../servicios/auth';

/**
 * Envuelve las páginas que exigen sesión. Al montar, pregunta al servidor si hay
 * sesión válida (cookie httpOnly). Mientras responde, no muestra nada; si no hay,
 * manda al login. La autorización real la hace el servidor en cada petición: esto
 * solo evita mostrar pantallas vacías a quien no inició sesión.
 */
export default function RutaProtegida({ children }) {
    const [estado, setEstado] = useState('verificando'); // verificando | dentro | fuera

    useEffect(() => {
        let vivo = true;
        sesionActual().then((u) => {
            if (vivo) setEstado(u ? 'dentro' : 'fuera');
        });
        return () => { vivo = false; };
    }, []);

    if (estado === 'verificando') return null;
    if (estado === 'fuera') return <Navigate to="/signin" replace />;
    return children;
}
